<template>
  <div class="member basicReport" v-loading="exploading" :element-loading-text="loadtxt">
    <div class="memberTop">
      <div class="memberInput">
        <ShowNavHead />
        <div class="flex">
          <div class="selectDate flex aic">
            <div class="flname">起止时间</div>
            <div class="block">
              <!-- <el-date-picker v-model="year" :picker-options="pickerOptions" type="year" value-format="yyyy" placeholder="选择年份">
              </el-date-picker> -->
              <el-date-picker v-model="mon1" type="month" style="margin-left: 20px;" :picker-options="pickerOptions" value-format="yyyy-MM" placeholder="选择开始月份" :clearable="false"></el-date-picker>
              <el-date-picker v-model="mon2" type="month" style="margin-left: 20px;" :picker-options="setDateRange" value-format="yyyy-MM" placeholder="选择结束月份" :clearable="false"></el-date-picker>
            </div>
            <el-input v-model="instname" v-if="activeName=='ProfitListDepartment2'" style="margin-left: 20px;" placeholder="请输入一级部门名称"></el-input>
            <el-input v-model="teamname" v-if="activeName=='ProfitListTeam2'" style="margin-left: 20px;" placeholder="请输入团队名称"></el-input>
            <!-- <el-input v-model="partnername" v-if="activeName=='ProfitListPartner2'" style="margin-left: 20px;" placeholder="请输入合伙人名称"></el-input> -->
            <el-input v-model="objname" v-if="activeName=='ProfitListObject2' || activeName=='ProfitListPartner2' || activeName=='ProfitListUser2'" style="margin-left: 20px;" placeholder="请输入项目名称"></el-input>
            <!-- <el-input v-model="username" v-if="activeName=='ProfitListUser2'" style="margin-left: 20px;" placeholder="请输入归属人名称"></el-input> -->
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
          <button class="exportButton" style="margin-left:10px;width: 65px;" @click="getList('0')">搜索</button>
        </div>
      </div>
      <div class="flex">
        <button class="exportButton" v-if="checkPermission(['basicReport_refresh'],permissionLists)" style="width: 100px;margin-right:20px" @click="visible=true">刷新报表</button>
        <!-- <button class="exportButton" style="width: 65px;margin-right:40px" @click="showsort">排序</button> -->
        <button class="exportButton" v-if="(tabids.length>0 && tableData.length>0)&&(checkPermission(['basicReport_export'],permissionLists))" style="width: 65px;margin-right:20px" @click="exportreport">导出</button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 105px;">
        <el-input v-model="StrUserNamee" size="small" style="width: 160px;margin-left: 20px;" placeholder="请输入业绩归属人"></el-input>
        <el-date-picker v-model="start" type="date" size="small" style="width: 160px;margin-left: 20px;" value-format="yyyy-MM-dd" placeholder="请选择立项时间" :clearable="false"></el-date-picker>
        <el-date-picker v-model="end" type="date" size="small" style="width: 160px;margin-left: 20px;" value-format="yyyy-MM-dd" placeholder="请选择立项时间" :clearable="false"></el-date-picker>
      </div>
      <div class="drop-footer">
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs" style="display: flex; justify-content: space-between;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>报表</el-breadcrumb-item>
          <el-breadcrumb-item>利润报表</el-breadcrumb-item>
          <el-breadcrumb-item>利润汇总表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="flex">
          <div class="refeshTime" style="margin-right: 20px;">最新报表月份：{{nowmonth}}</div>
          <div class="refeshTime">报表刷新时间：{{refeshTime}}</div>
        </div>
      </div>
      <div class="basicTable" style="background-color: #fff;" v-if="checkPermission(['basicReport_list'],permissionLists)">
        <div class="ftabs">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="item in tabids" :key="item.Strroletable" :label="item.StrroleName" :name="item.Strroletable" v-if="item.StrroleName.indexOf('刷新') ==-1 && item.StrroleName.indexOf('业务团队') ==-1 && item.Strrolecont == 'basicReport'" :disabled="loading">
              <el-popover slot="label" v-if="item.Strroletable=='ProfitListDepartment2'" placement="bottom" width="200" trigger="hover" content="查看服务中心/分公司的利润。">
                <span slot="reference">{{item.StrroleName}}<i class="el-icon-question"></i></span>
              </el-popover>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-table :data="tableData" :key="itemKey" :highlight-current-row="true" border :max-height="(tableHeight-240) > 350 ? tableHeight-240 : 350" style="width: 99%" row-key="name" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="loading" element-loading-text="拼命加载中" @sort-change="handleSortChange" element-loading-spinner="el-icon-loading" @current-change="chengebcg" :header-cell-class-name="handleHeaderCellClass">
          <template v-for="(item,index) in tableTitle">
            <el-table-column :key="index" :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :width="item.StrColumName=='一级部门' ||item.StrColumName=='二级部门' || item.StrColumName=='三级部门' ? '120px' : item.StrColumName.length>4 && item.StrColumName.length<8 ? '125px' : item.StrColumName.length>8 ? '142px' : item.StrColumName=='在职人数' || item.StrColumName=='社保人数' ? '105px' : '100px' " :fixed="item.StrColumName=='一级部门' ||item.StrColumName=='二级部门' || item.StrColumName=='三级部门'|| item.StrColumName=='合伙人'|| item.StrColumName=='业务团队'|| item.StrColumName=='业务部门' || item.StrColumName=='业绩归属人' || item.StrColumName.indexOf('项目名称')>-1 ? true : false" sortable="custom">
              <template slot-scope="scope">
                <span v-if="(item.StrColumName=='二级部门' && scope.row[item.StrColumId]!=null && scope.row[item.StrColumId].indexOf('--')>-1)|| item.StrColumName=='三级部门'">
                  {{scope.row[item.StrColumId]!=null && scope.row[item.StrColumId].indexOf('级总计')>-1 ? '--' : scope.row[item.StrColumId]}}
                </span>
                <span v-else-if="(item.StrColumName=='二级部门'||item.StrColumName=='一级部门') && scope.row[item.StrColumId]!=null && scope.row[item.StrColumId].indexOf('--')==-1" class="obj_name cp" title="点击查看明细" @click="goDetail(scope.row[item.StrColumId], item.StrColumName=='一级部门' ? 'dep1' : 'dep2')" :style="{color: scope.row.isHighlight ? '#fff' : '#19bd92'}">
                  {{scope.row[item.StrColumId]!=null && scope.row[item.StrColumId].indexOf('级总计')>-1 ? '--' : scope.row[item.StrColumId]}}
                </span>
                <span v-else-if="item.StrColumName=='项目名称' && scope.row.strObjName!=null && scope.row.strObjName.indexOf('--')==-1" class="obj_name cp" title="点击查看明细" @click="goDetail(scope.row.strObjName,'obj')" :style="{color: scope.row.isHighlight ? '#fff' : '#19bd92'}">
                  {{scope.row.strObjName}}
                </span>
                <span v-else-if="item.StrColumName=='项目名称' && scope.row.strObjName!=null && scope.row.strObjName.indexOf('--')!=-1">{{scope.row.strObjName}}</span>
                <span v-else>{{scope.row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="total && total>0">
          <el-pagination @current-change="changeBPage" :current-page.sync="currpage" :page-size="pagenum" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <div class="reportdialog">
      <el-dialog title="刷新报表" :visible.sync="visible" width="384px">
        <div>请确认是否刷新 <span style="font-weight: 600;">{{this.mon2}}</span> 的报表</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visible = false">取消</button>
          <button class="search" @click="getList('1')" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>

      <el-dialog title="报表导出" :visible.sync="visibleExp" width="384px">
        <el-form>
          <el-form-item label="是否带总计：">
            <el-select v-model="isWithTotal" placeholder="请选择">
              <el-option label="带总计导出" :value="0"></el-option>
              <el-option label="不带总计导出" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visibleExp = false">取消</button>
          <button class="search" @click="exportreport()" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>

<script>
  import xz from "@/common";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        exploading: false,
        hasRefresh: false, //刷新按钮
        visible: false,
        itemKey: '',
        activeName: '',
        nowmonth: '',
        loadtxt: '',
        tableHeight: 0,
        tableTitle: [],
        tableData: [],
        instname: '',
        teamname: '',
        partnername: '',
        objname: '',
        username: '',
        currmon: '',
        StrUserNamee: '', //业绩归属人
        start: '',
        end: '',
        year: new Date().getFullYear().toString(),
        // cmon: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()),
        // cmon: '2022-08',
        // mon1:new Date().getFullYear() + '-01',
        mon1: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()),
        mon2: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()),
        currpage: 1,
        pagenum: 100,
        loading: false,
        total: null,
        role: '',
        isPartner: '',
        refeshTime: '',
        showDropScreen: -1,
        // 禁用日期范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        setDateRange: {
          disabledDate: this.disabledDate
        },
        tabids: [],
        lastid: '',
        orderlist: {},
        orderArray: [],
        visibleExp: false,
        isWithTotal: 0,
        isAdmPower: false, //是否有管理员权限
        // 按钮权限参数
        butQuery: {
          path: '/basicReport',
          powerEnName: 'reportForms'
        },
        permissionLists: []
      };
    },
    async created() {
      this.calHeight();
      this.getButtonPower()
      if (new Date().getMonth() == 0) {
        this.year = (new Date().getFullYear() - 1).toString(),
          this.mon1 = (new Date().getFullYear() - 1) + '-' + 12;
        this.mon2 = (new Date().getFullYear() - 1) + '-' + 12
      }
      this.role = localStorage.loginRoletype;
      this.isPartner = localStorage.isPartner;
      let tab = JSON.parse(localStorage.tableids);
      let r4 = {
        Roleid: 'PR004',
        StrroleName: '利润汇总表（按项目）',
        Strrolecont: 'basicReport',
        Strroletable: 'ProfitListObject2'
      }
      let r5 = {
        Roleid: 'PR005',
        StrroleName: '利润汇总表（按业绩归属人）',
        Strrolecont: 'basicReport',
        Strroletable: 'ProfitListUser2'
      }
      tab.push(r4)
      tab.push(r5)
      const resList = new Map();
      tab = tab.filter((tab) => !resList.has(tab.Roleid) && resList.set(tab.Roleid, 1));
      // console.log('tab',tab)
      if (tab && tab != undefined && tab.length > 0) {
        tab.forEach((element, index) => {
          element.Strroletable = element.Strroletable + '2';
          if (element.Strrolecont == 'basicReport') {
            this.tabids.push(element)
          }
        });
        if (this.tabids[0].Strroletable != 'ProfitListTeam2') {
          this.activeName = this.tabids[0].Strroletable;
          this.lastid = this.tabids[0].Strroletable;
        } else {
          this.activeName = this.tabids[1].Strroletable;
          this.lastid = this.tabids[1].Strroletable;
        }
      }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
            this.judgePower()
          } else {
            this.permissionLists = []
          }
        })
      },
      //判断是否有管理员权限
      judgePower() {
        let data = {
          currpage: 1,
          perpage: 1000,
          keyword: '',
          strWorkState: '',
          strstation: '',
          strorgancode: ''
        }
        xz.getauthUserBasicReport(data).then(res => {
          if (res.status == 'ok') {
            if (res.totalcount > 0) {
              let a = res.msg.some(ele => Cookies.get("userid-b") == ele.Userid)
              this.isAdmPower = a ? true : false;
              this.getList('0');
            }
          } else {
            this.$message.error('获取权限出错')
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      disabledDate(time) {
        // return time.getTime() > new Date(this.year + '-12-31').getTime() ||
        //   time.getTime() < new Date(this.year + '-01-01').getTime()
        return (time.getTime() < new Date(this.mon1).getTime() || time.getTime() > new Date().getTime())
      },
      getMonthBetween() {
        this.currmon = '';
        let start = this.mon1;
        let end = this.mon2;
        var s = start.split("-");
        var e = end.split("-");
        var min = new Date();
        var max = new Date();
        min.setFullYear(s[0], s[1] * 1 - 1, 1); //开始日期
        max.setFullYear(e[0], e[1] * 1 - 1, 1); //结束日期
        var curr = min;
        while (curr <= max) {
          // console.log(moment(curr).format('YYYY-MM'));
          var month = curr.getMonth();
          this.currmon = this.currmon ? this.currmon + ',' + moment(curr).format('YYYY-MM') : moment(curr).format('YYYY-MM');
          curr.setMonth(month + 1);
        }
        console.log(this.currmon)
      },
      getTableHead() {
        this.getMonthBetween();
        let headData = {
          year: this.year,
          userid: Cookies.get("userid-b"),
          instname: '',
          teamname: '',
          partnername: '',
          objname: '',
          username: '',
          currpage: 1,
          pagenum: 1000,
          currmon: this.currmon
        }
        xz.gettestreport('rtnreporthead', this.activeName, headData).then(res => {
          if (res.status == 'ok') {
            this.tableTitle = res.msg;
            this.getTabData();
          } else {
            this.$message.error('系统出错')
            this.tableTitle = [];
          }
        })
      },
      load(tree, treeNode, resolve) {
        // console.log(tree, treeNode, resolve)
        let keyname, key, keyname2, key2;
        keyname = this.activeName == 'ProfitListDepartment2' ? treeNode.level === 0 ? 'StrDep1-=-' : 'StrDep2-=-' : this.activeName == 'ProfitListPartner2' ? 'StrPartnerName-=-' : this.activeName == 'ProfitListObject2' ? 'StrObjName-=-' : 'StrUserName-=-';
        key = this.activeName == 'ProfitListDepartment2' ? treeNode.level === 0 ? tree.StrDep1 : (tree.StrDep2 && tree.StrDep2 != null ? tree.StrDep2 : tree.StrDep1) : this.activeName == 'ProfitListPartner2' ? tree.StrPartnerName : tree.StrUserName;
        keyname2 = this.activeName == 'ProfitListDepartment2' || this.activeName == 'ProfitListObject2' ? '' : ',StrObjName-like-';
        key2 = this.activeName == 'ProfitListDepartment2' || this.activeName == 'ProfitListObject2' ? '' : this.objname;
        let data = {
          year: this.year,
          currmon: this.currmon,
          instcode: this.isAdmPower ? '0' : localStorage.gancode,
          userid: Cookies.get("userid-b"),
          // instname: this.activeName == 'ProfitListDepartment2' ? treeNode.level === 0 ? tree.StrDep1 : (tree.StrDep2 && tree.StrDep2 != null ? tree.StrDep2 : tree.StrDep1) : '',
          // partnername: this.activeName == 'ProfitListPartner2' ? tree.StrPartnerName : '',
          // teamname: this.activeName == 'ProfitListTeam2' ? tree.strorganname : '',
          // username: this.activeName == 'ProfitListUser2' ? tree.StrUserName : '',
          keyname: key2 ? keyname + key + keyname2 + key2 : keyname + key,
          lvl: treeNode.level === 0 ? 2 : 3,
          currpage: 1,
          pagenum: 1000,
          orderby: this.orderArray
        }
        xz.gettestreport('rtnreportdata', this.activeName, data).then(res => {
          if (res.status == 'ok' && res.msg.length > 0) {
            res.msg.forEach((element, index) => {
              // let name = element.StrDep1 + element.StrDep2 + element.StrDep3 + element.StrObjName;
              // this.$set(element, 'name', name)
              switch (this.activeName) {
                case 'ProfitListDepartment2':
                  let name = element.StrDep1 + element.StrDep2 + element.StrDep3 + element.StrObjName + Math.random();
                  this.$set(element, 'name', name);
                  break;
                case 'ProfitListPartner2':
                  this.$set(element, 'name', element.StrPartnerName + element.StrUserName + index);
                  break;
                case 'ProfitListTeam2':
                  this.$set(element, 'name', element.strorganname + element.StrObjName + index);
                  break;
                case 'ProfitListUser2':
                  this.$set(element, 'name', element.StrDepartment + element.StrUserName + element.StrObjName + index);
                  break;
              }
              if (treeNode.level === 0) {
                this.$set(element, 'hasChildren', treeNode.level === 0 && this.activeName == 'ProfitListDepartment2' ? true : false)
                // if (element.deptnum >= 0) {
                //   this.$set(element, 'hasChildren', true)
                // }
                if (index + 1 == res.msg.length) {
                  resolve(res.msg)
                }
              } else {
                if (element.StrDep3 == '--') {
                  // let name = element.StrDep2 + '-' + element.StrObjName
                  this.$set(element, 'StrDep2', element.StrDep2 + '-' + element.StrObjName)
                }
                resolve(res.msg)
              }
            });
          } else {
            resolve([])
          }
        })
      },
      getTabData() {
        this.loading = true;
        this.tableData = [];
        let keyname, key;
        keyname = this.activeName == 'ProfitListDepartment2' ? 'StrDep1-like-' : 'strObjName-like-';
        key = this.activeName == 'ProfitListDepartment2' ? this.instname : this.objname;
        if (this.StrUserNamee) {
          key = key + 'StrUserNamee-like-' + this.StrUserNamee + ','
        }
        if (this.start && this.end) {
          key = key + 'DtInitDate|>|' + this.start + ',' + 'DtInitDate|<|' + this.end
        }
        let data = {
          year: this.year,
          currmon: this.currmon,
          userid: Cookies.get("userid-b"),
          keyname: key ? keyname + key : '',
          instcode: this.isAdmPower ? '0' || this.role == 'Promawang' : localStorage.gancode,
          lvl: (this.activeName == 'ProfitListUser2' || this.activeName == 'ProfitListPartner2') && this.objname ? 2 : 1,
          currpage: this.currpage,
          pagenum: this.pagenum,
          orderby: this.orderArray
        }
        xz.gettestreport('rtnreportdata', this.activeName, data).then(res => {
          if (res.status == 'ok' && res.msg.length > 0) {
            if (this.activeName != 'ProfitListObject2') {
              res.msg.forEach((element, index) => {
                // if (element.deptnum > 1) {
                //   this.$set(element, 'hasChildren', true)
                // }
                switch (this.activeName) {
                  case 'ProfitListDepartment2':
                    let name = element.StrDep1 + element.StrDep2 + element.StrDep3 + element.StrObjName;
                    this.$set(element, 'name', name);
                    break;
                  case 'ProfitListPartner2':
                    this.$set(element, 'name', element.StrPartnerName + element.StrUserName);
                    break;
                  case 'ProfitListTeam2':
                    this.$set(element, 'name', element.strorganname + element.StrObjName + index);
                    break;
                  case 'ProfitListUser2':
                    this.$set(element, 'name', element.StrDepartment + element.StrUserName + element.StrObjName);
                    break;
                }
                this.$set(element, 'hasChildren', (this.activeName == 'ProfitListUser2' || this.activeName == 'ProfitListPartner2') && this.objname ? false : true)
                if (index + 1 == res.msg.length) {
                  this.tableData = res.msg;
                  this.itemKey = Math.random();
                  this.total = res.msg[0].totalCount;
                }
              });
            } else {
              this.tableData = res.msg;
              this.total = res.msg[0].totalCount;
            }
          } else {
            this.tableData = [];
          }
          this.loading = false
        })
      },
      //切换表格
      handleClick(tab) {
        if (this.lastid == tab.name) {
          return
        } else {
          this.orderArray = [];
          this.tableTitle = [];
          this.handleHeaderCellClass('', '', '', '')
          this.clear();
          this.tableData = [];
          this.activeName = tab.name;
          this.getTableHead();
          this.lastid = tab.name;
        }
      },
      clear() {
        this.instname = '';
        this.teamname = '';
        this.partnername = '';
        this.objname = '';
        this.username = ''
        this.StrUserNamee = '';
        this.start = '';
        this.end = '';
      },
      //分页
      changeBPage(val) {
        this.currpage = val;
        this.getTabData();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currpage = 1;
        this.perpage = val;
        this.getTabData();
      },
      showExport() {
        this.visibleExp = true;
      },
      //报表导出
      exportreport() {
        let keyname, key;
        keyname = this.activeName == 'ProfitListDepartment2' ? 'StrDep1-like-' : 'strObjName-like-';
        key = this.activeName == 'ProfitListDepartment2' ? this.instname : this.objname;
        let data = {
          year: this.year,
          currmon: this.currmon,
          userid: Cookies.get("userid-b"),
          keyname: key ? keyname + key : '',
          instcode: this.isAdmPower ? '0' : localStorage.gancode,
          // teamname: this.teamname,
          // instname: this.instname,
          // partnername: this.partnername,
          // objname: this.objname,
          // username: this.username,
          lvl: 0,
          currpage: 1,
          pagenum: 100000,
          orderby: this.orderArray
        }
        this.loadtxt = '正在导出···';
        this.exploading = true;
        xz.gettestreport('downloadreport', this.activeName, data).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: '/exportRecordList'
            })
          } else {
            this.$message({
              message: "导出错误",
              type: "error"
            })
          }
          this.exploading = false;
        })
        // this.$router.push({
        //   path: '/employee-exportRecordList'
        // })
      },
      getList(refesh) {
        this.visible = false;
        let data = {
          refesh,
          lvl: '0',
          arrmon: this.mon2
        }
        refesh == '1' ? (this.loadtxt = '正在刷新···', this.exploading = true) : '';
        // xz.gettestreportrefesh(data).then(res => {
        //   if (res.status == 'ok') {
        //     moment.locale("zh-cn");
        //     if (refesh == '0') {
        //       this.formatdate(res.msg)
        //     } else {
        //       this.$message.success('刷新成功');
        //       this.refesh('0');
        //       this.exploading = false;
        //     }
        //   } else {
        //     this.exploading = false;
        //     refesh == '0' ? '' : this.$message.error('刷新失败');
        //   }
        // })
        if (refesh == '0') {
          xz.gettestreportrefesh(data).then(res => {
            if (res.status == 'ok') {
              moment.locale("zh-cn");
              this.formatdate(res.msg)
            } else {
              this.exploading = false;
            }
          })
        } else if (refesh == '1') {
          xz.gettestreportrefesh(data);
          this.exploading = false;
          this.$message({
            message: '后台正在刷新，预计刷新时间为五分钟',
            duration: 5000
          })
        }
      },
      formatdate(msg) {
        if (msg.reportdate) {
          this.refeshTime = moment(new Date(msg.reportdate)).format('YYYY-MM-DD HH:mm:ss');
        } else {
          this.refeshTime = '';
        }
        this.nowmonth = msg.currmon;
        // this.cmon = msg.currmon;
        this.getTableHead();
      },
      chengebcg(currentRow, oldCurrentRow) {
        console.log(currentRow, oldCurrentRow)
        this.$set(currentRow, 'isHighlight', true);
        this.$set(oldCurrentRow, 'isHighlight', false)
      },
      //排序
      handleSortChange({
        column,
        prop,
        order
      }) {
        this.orderArray = [];
        if (order) {
          //参与排序
          let flagIsHave = false;
          this.orderArray.forEach((element) => {
            if (element.prop === prop) {
              element.order = order;
              flagIsHave = true;
            }
          });
          if (!flagIsHave) {
            this.orderArray.push({
              prop: prop,
              order: order,
            });
          }
        } else {
          //不参与排序
          this.orderArray = this.orderArray.filter((element) => {
            return element.prop !== prop
          });
        }
        this.getTabData();
        console.log('ff', this.orderArray)
      },
      handleHeaderCellClass({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        this.orderArray.forEach((element) => {
          if (column.property === element.prop) {
            column.order = element.order;
          }
        });
      },
      goDetail(obj, type) {
        const routerUrl = this.$router.resolve({
          path: '/detailsReport',
          query: {
            custname: type == 'obj' ? obj : '',
            mon: this.mon2,
            hiddenleft: true,
            dep1: type == 'dep1' ? obj : '',
            dep2: type == 'dep2' ? obj : '',
            name: obj
          }
        })
        window.open(routerUrl.href, '_blank')
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
      },
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      }
    }
  }
</script>
<style scoped>
  .ftabs {
    background: #fff;
    width: 99%;
  }

  .refeshTime {
    font-size: 14px;
    color: #909399;
    margin-right: 30px;
  }

  .obj_name {
    text-decoration-line: underline;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    padding-top: 10px;
  }
  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>

<style>
  .basicReport .ftabs .el-tabs__header {
    margin: 0;
  }

  .basicTable .el-table th.el-table__cell {
    background: #f5f7fa;
  }

  .selectDate .el-input {
    width: 160px;
  }

  .selectDate .el-input__inner {
    height: 35px;
    line-height: 35px;
  }

  .selectDate .el-input__icon {
    height: 35px;
    line-height: 35px;
  }

  .reportdialog .el-dialog__body {
    padding: 5px 20px;
  }

  .basicTable .el-table .sort-caret.descending {
    border-top-color: #19bd92
  }

  .basicTable .el-table .sort-caret.ascending {
    border-bottom-color: #19bd92
  }

  .basicTable .el-table .ascending .sort-caret.ascending {
    border-bottom-color: red;
  }

  .basicTable .el-table .descending .sort-caret.descending {
    border-top-color: red;
  }
</style>